import RequestBase from '../Resources/RequestBase';

export class CreateApplicationRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Applications';
        this.method = 'POST';
        this.parameters = [
            'salutation',
            'firstName',
            'lastName',
            'buildingName',
            'buildingNumber',
            'streetName',
            'city',
            'postCode',
            'country',
            'mobilePhone',
            'dateOfBirth',
            'tradingName',
            'businessLandline',
            'yearsTrading',
            'monthlyTurnOver',
            'businessType',
            'businessAddress1',
            'businessCity',
            'businessPostcode',
            'businessLegalName'
        ];
        this.test = true;
        this.success = success;
        this.error = {
            statusCode: 403,
            statusMessage: 'Bad Request',
            body: 'Wrong parameters'
        };
        this.data = {};
    }
}

export class UpdateApplicationRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Applications';
        this.method = 'POST';
        this.contentType = 'application/json';
        this.parameters = [
            'buildingName',
            'buildingNumber',
            'streetName',
            'city',
            'postCode',
            'country',
            'customerId'
        ];
        this.test = true;
        this.success = success;
        this.error = {
            statusCode: 403,
            statusMessage: 'Bad Request',
            body: 'Wrong parameters'
        };
        this.data = {};
    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Applications.js